import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env';
import { map } from 'rxjs/operators';
import { ResellerProfile, ResellerProfiles } from '@models/reseller/profile';
import { SuperAccountSettings } from '@models/superaccount/settings';
import { compare } from 'fast-json-patch';

@Injectable({
  providedIn: 'root'
})
export class ResellerService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getProfiles(): Observable<ResellerProfiles> {
    return this.http.get<Response>(this.baseUrl + 'subaccount/profile', {}).pipe(
      map(data => {
        return ResellerProfiles.deserialize({
          data: (data && (data as any) ? ((data as any) as Array<string>) : []).map(data2 => ResellerProfile.deserialize(data2)),
          total: (data as any).length
        });
      })
    );
  }

  getProfile(idProfile): Observable<ResellerProfile> {
    return this.http
      .get<Response>(this.baseUrl + 'subaccount/profile/' + idProfile, {})
      .pipe(map(data => ResellerProfile.deserialize(data)));
  }

  addProfile(resellerProfile: ResellerProfile) {
    return this.http.post(this.baseUrl + 'subaccount/profile', resellerProfile).pipe(map(data => ResellerProfile.deserialize(data)));
  }

  removeProfile(resellerProfile: ResellerProfile) {
    const options = { responseType: 'text' as 'json', body: {} };
    return this.http.delete(this.baseUrl + 'subaccount/profile/' + resellerProfile.idSubaccountProfile, options);
  }

  editProfile(resellerProfileOld, resellerProfileNew) {
    const patchData = compare(resellerProfileOld, resellerProfileNew);
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    return this.http
      .patch<Response>(this.baseUrl + 'subaccount/profile/' + resellerProfileOld.idSubaccountProfile, patchData, { headers: patchHeaders })
      .pipe(map(data => ResellerProfile.deserialize(data)));
  }

  getActivableServices(): Observable<Array<string>> {
    return this.http.get<Response>(this.baseUrl + 'subaccount/profile/activableServices').pipe(
      map(data => {
        return (data as any) as Array<string>;
      })
    );
  }

  getSuperAccountSettings(): Observable<SuperAccountSettings> {
    return this.http.get<Response>(this.baseUrl + 'superaccount/settings', {}).pipe(map(data => SuperAccountSettings.deserialize(data)));
  }

  editSuperAccountSettings(supperAccountSettingsOld, supperAccountSettingsNew): Observable<SuperAccountSettings> {
    const settingsPatch = compare(supperAccountSettingsOld, supperAccountSettingsNew);
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    return this.http
      .patch<Response>(this.baseUrl + 'superaccount/settings', settingsPatch, { headers: patchHeaders })
      .pipe(map(data => SuperAccountSettings.deserialize(data)));
  }
}
